
import { useGetPreventas } from '@/shared/actions/erp';
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IDataPreventa } from '@/shared/interfaces';
import { Grid } from '@mui/material';
import { useTableColumnsPreventa } from '@/shared/hooks/useTableColumnsPreventa';
import { PermissionsEnum } from '@/auth/interfaces';
import CustomSearchFilterSupervisorVenta from '../../../prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta';
import { EstadoPreventaEnum } from '@/shared';

export default function PreventaSolicitudLiberacionValorInstalacionPage() {

  useCheckPermissions(PermissionsEnum.api_view_preventa);

  const { columnsPreventaSolicitudValorInstalacion } = useTableColumnsPreventa(EstadoPreventaEnum.FINALIZADO);

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventas({
      estado_preventa: EstadoPreventaEnum.EN_ESPERA,
      identificacion: searchTerm,
      page: pageIndex + 1,
      page_size: pageSize,
      fecha_preventa_before: dateBefore,
      fecha_preventa_after: dateAfter,
      no_cobrar: true,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });


  return (
    <Grid container spacing={2} >
      <Grid item xs={12}>
        <CustomSearchFilterSupervisorVenta
          onChange={onChangeFilter}
          value={globalFilter}
          text="por Identificación"

          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}

          //vendedor={vendedor}
          setVendedor={setVendedor}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<IDataPreventa>
          columns={columnsPreventaSolicitudValorInstalacion}
          data={preventasRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={preventasRes?.data?.count}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          enableColumnActions={true}

          // // actions
          actionsColumnSize={120}
          // crud
          canDelete={false}
          positionActionsColumn='first'
          enableEditing={false}
        />
      </Grid>
    </Grid>
  );


}

